import { render, staticRenderFns } from "./ModalTreatment.vue?vue&type=template&id=5ee00a0e&scoped=true"
import script from "./ModalTreatment.vue?vue&type=script&lang=js"
export * from "./ModalTreatment.vue?vue&type=script&lang=js"
import style0 from "./ModalTreatment.vue?vue&type=style&index=0&id=5ee00a0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee00a0e",
  null
  
)

export default component.exports